import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import isMatch from 'lodash/isMatch'

const baseState = {
    addresses: [],
    allAddresses: [],
    active: {},
    subscription: {},
    nextSubscription: {},
    loading: false,
    loadingAll: false,
    edit: true,
    savingAddress: false,
    savingAddressError: null,
}

function isExistingAddress(state, address) {
    !!find(state.addresses, (a) => isMatch(a, address))
}

export default function reducer(state = baseState, action) {
    switch (action.type) {
        case 'GET_ADDRESSES':
            return { ...state, loading: true }
        case 'GET_ADDRESSES_FAILED':
            return { ...state, loading: false }
        case 'GET_ADDRESSES_SUCCESS': {
            return {
                ...state,
                addresses: action.payload,
                edit: false,
                loading: false,
            }
        }
        case 'GET_ALL_ADDRESSES':
            return { ...state, allAddresses: [], loadingAll: true }
        case 'GET_ALL_ADDRESSES_FAILED':
            return { ...state, loadingAll: false }
        case 'GET_ALL_ADDRESSES_SUCCESS':
            return {
                ...state,
                allAddresses: action.payload,
                loadingAll: false,
            }
        case 'STORE_SUBSCRIPTION_ADDRESS':
            return { ...state }
        case 'STORE_SUBSCRIPTION_ADDRESS_SUCCESS': {
            const address = action.payload
            const active = isEmpty(state.active) ? address : state.active
            if (isExistingAddress(state, address)) {
                return {
                    ...state,
                    active,
                    subscription: address,
                }
            } else {
                const addresses = [address, ...state.addresses]
                return {
                    ...state,
                    addresses,
                    active,
                    subscription: address,
                }
            }
        }
        case 'STORE_SUBSCRIPTION_ADDRESS_FAILED':
            return { ...state } // TODO: Sende melding til bruker?
        case 'SET_SUBSCRIPTION_ADDRESS': {
            return {
                ...state,
                subscription: action.payload,
            }
        }
        case 'SET_NEXT_SUBSCRIPTION_ADDRESS': {
            return {
                ...state,
                nextSubscription: action.payload,
            }
        }
        case 'STORE_ADDRESS': {
            const address = action.payload
            return {
                ...state,
                addresses: [address, ...state.addresses],
                active: address,
            }
        }
        case 'USER_LOGOUT':
            return { ...baseState }
        case 'SET_ACTIVE_ADDRESS':
            return {
                ...state,
                active: action.payload,
            }
        case 'TOGGLE_EDIT_ADDRESS':
            return {
                ...state,
                edit: action.payload != undefined ? action.payload : !state.edit,
            }
        case 'RESET_ADDRESS_FORM':
            return {
                ...state,
                savingAddress: false,
                savingAddressError: null,
            }
        case 'SAVE_ADDRESS':
            return {
                ...state,
                savingAddress: true,
                savingAddressError: null,
            }
        case 'SAVE_ADDRESS_FAILED':
            return {
                ...state,
                savingAddress: false,
                savingAddressError: action.payload,
            }
        case 'SAVE_ADDRESS_SUCCESS':
            return {
                ...state,
                allAddresses: [
                    action.payload,
                    ...state.allAddresses.filter((a) => a.addressId !== action.payload.addressId),
                ],
                savingAddress: false,
            }
        default:
            return state
    }
}
